"use client";
import { SwitchTransition, CSSTransition } from "react-transition-group";
import { ReactNode, useRef } from "react";
import { usePathname } from "next/navigation";

interface PageTransitionProps {
  children: ReactNode;
}

const PageTransition = ({ children }: PageTransitionProps) => {
  const pathname = usePathname();
  const nodeRef = useRef<HTMLDivElement>(null);

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={pathname}
        nodeRef={nodeRef}
        timeout={{ enter: 300, exit: 0 }}
        classNames="fade"
        unmountOnExit
      >
        <div ref={nodeRef} className="page-transition-wrapper">
          {children}
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
};

export default PageTransition;
